import { useQuery } from "@tanstack/react-query";
import { Migration } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
export const MIGRATION_STATE_QUERY_KEY = ["migration-state"];
const useMigrationState = (args) => {
  var _a, _b;
  const { data, isLoading } = useQuery({
    queryKey: MIGRATION_STATE_QUERY_KEY,
    queryFn: () => onError(Migration.status(), (error) => UserNotification.error(error.message)),
    enabled: (_a = args == null ? void 0 : args.enabled) != null ? _a : true,
    retry: 2,
    refetchInterval: (_b = args == null ? void 0 : args.refetchInterval) != null ? _b : false
  });
  return {
    currentStep: data,
    isLoading
  };
};
export default useMigrationState;
